import { DealInformation } from "../../../../types/deal";
import { VisitaList } from "./VisitaList";
import { Dispatch, SetStateAction } from "react";
import { CurrentComponent } from "./DealInformation";
import { SaveButton } from "../../../ui/SaveButton";
import Person2RoundedIcon from '@mui/icons-material/Person2Rounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import AttachMoneyRoundedIcon from '@mui/icons-material/AttachMoneyRounded';

interface Props {
    deal: DealInformation;
    setCurrentComponent: Dispatch<SetStateAction<CurrentComponent>>;
}

export function DealDetails({ deal, setCurrentComponent }: Props) {
    return (
        <div className="flex justify-between h-full gap-x-3 flex-shrink w-full overflow-hidden">

            <div className="border border-gray-500 rounded-md py-3 w-full flex flex-col">
                <div className="flex justify-between px-2">
                    <p className="font-semibold text-[16px]">Visitas</p>

                    <SaveButton
                        onClick={() => {
                            setCurrentComponent({ component: "RegisterVisitaForm", visitaId: 0 })
                        }}
                        text="+ Agregar visita"
                        type="button"/>
                </div>

                <div className="overflow-hidden flex-1">
                    <VisitaList
                        visitas={deal.visitas}
                        setCurrentComponent={setCurrentComponent} />
                </div>
            </div>

            <div className="border border-gray-500 rounded-md p-3 w-[400px] overflow-auto">
                <p className="font-semibold text-lg pb-3">Información de la camapaña</p>

                <div className="flex justify-between font-semibold pb-2">
                    <div className="flex gap-x-1 items-center">
                        <Person2RoundedIcon sx={{ height: 20, width: 20 }}/>
                        <p>Prospectador</p>
                    </div>
                    <p className="text-gray-600">{deal.prospectador}</p>
                </div>

                <div className="flex justify-between font-semibold pb-2">
                    <div className="flex gap-x-1 items-center">
                        <CalendarMonthRoundedIcon sx={{ height: 20, width: 20 }}/>
                        <p>Fecha de inicio</p>
                    </div>
                    <p className="text-gray-600">{deal.fechaInicio}</p>
                </div>

                <div className="flex justify-between font-semibold pb-2">
                    <div className="flex gap-x-1 items-center">
                        <CalendarMonthRoundedIcon sx={{ height: 20, width: 20 }}/>
                        <p>Fecha de fin</p>
                    </div>
                    <p className="text-gray-600">{deal.fechaFin}</p>
                </div>

                <p className="font-semibold text-lg py-3">Información de las visitas</p>

                <div className="flex justify-between font-semibold pb-2 items-center">
                    <div className="flex gap-x-1 items-center">
                        <AttachMoneyRoundedIcon sx={{ height: 20, width: 20 }}/>
                        <p>Intenciones vendidas</p>
                    </div>
                    <p className="text-gray-600">{deal.intencionesVendidas}</p>
                </div>
            </div>
        </div>
    );
}